export default __webpack_public_path__ + "static/media/grandcanyonaankomstKlein.61348371.jpg";